import FJLoadLocalforageStore from './FJLoadLocalforageStore.js';
import { TARGET_LANGUAGE_LIST } from '../config/FJVideoSettingDataConfig';

const STORAGE_KEY = 'user-behavior';

const DEFAULT_STATE = {
    textLanguageKey: null,
    cropTipSeen: false,
};

class FJUserBehaviorStore {
    _cache = null;
    _loadPromise = null;

    async _load() {
        if (this._cache) {
            return this._cache;
        }
        if (!this._loadPromise) {
            this._loadPromise = FJLoadLocalforageStore.getItem(STORAGE_KEY).then(data => {
                this._cache = { ...DEFAULT_STATE, ...(data || {}) };
                return this._cache;
            });
        }
        return this._loadPromise;
    }

    async _save(partial) {
        const data = await this._load();
        Object.assign(data, partial);
        await FJLoadLocalforageStore.setItem(STORAGE_KEY, data);
        return data;
    }

    _isValidTextLanguageKey(key) {
        return TARGET_LANGUAGE_LIST.some(item => item.value === key);
    }

    async getTextLanguageKey() {
        const data = await this._load();
        const key = data.textLanguageKey;
        return this._isValidTextLanguageKey(key) ? key : null;
    }

    async setTextLanguageKey(key) {
        if (!this._isValidTextLanguageKey(key)) {
            return;
        }
        await this._save({ textLanguageKey: key });
    }

    async hasSeenCropTip() {
        const data = await this._load();
        return !!data.cropTipSeen;
    }

    async setCropTipSeen() {
        await this._save({ cropTipSeen: true });
    }
}

const userBehaviorStore = new FJUserBehaviorStore();

export default userBehaviorStore;
